import React from 'react';

function UVABibliography() {
    return (
        <div>
            <div className="row">
                <h1 className="page-header">University of Virginia Special Collections Accession List pre-2005</h1>

                <div className="row">
                    <ul className="uva-thumbnail-list">
                        <li className="uva-thumbnail-item">
                            <a href={`${process.env.PUBLIC_URL}/images/scans/UVA/UVA-Library-Collection-List_1-17.jpg`}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/UVA-Library-Collection-List_1-17_thumb.jpg`}
                                    alt="Arthur Mervyn book cover"
                                    className="uva-thumbnail-img"
                                />
                            </a>
                            <div className="caption">
                                <h4>#1-17</h4>
                            </div>
                        </li>
                        <li className="uva-thumbnail-item">
                            <a href={`${process.env.PUBLIC_URL}/images/scans/UVA/UVA-Library-Collection-List_18-34.jpg`}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/UVA-Library-Collection-List_18-34_thumb.jpg`}
                                    alt="Arthur Mervyn book cover"
                                    className="uva-thumbnail-img"
                                />
                            </a>
                            <div className="caption">
                                <h4>#18-34</h4>
                            </div>
                        </li>
                        <li className="uva-thumbnail-item">
                            <a href={`${process.env.PUBLIC_URL}/images/scans/UVA/UVA-Library-Collection-List_35-53.jpg`}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/UVA-Library-Collection-List_35-53_thumb.jpg`}
                                    alt="Arthur Mervyn book cover"
                                    className="uva-thumbnail-img"
                                />
                            </a>
                            <div className="caption">
                                <h4>#35-53</h4>
                            </div>
                        </li>
                    </ul>

                    <ul className="uva-thumbnail-list">
                        <li className="uva-thumbnail-item">
                            <a href={`${process.env.PUBLIC_URL}/images/scans/UVA/UVA-Library-Collection-List_54-61.jpg`}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/UVA-Library-Collection-List_54-61_thumb.jpg`}
                                    alt="Arthur Mervyn book cover"
                                    className="uva-thumbnail-img"
                                />
                            </a>
                            <div className="caption">
                                <h4>#54-61</h4>
                            </div>
                        </li>
                        <li className="uva-thumbnail-item">
                            <a href={`${process.env.PUBLIC_URL}/images/scans/UVA/UVA-Library-Collection-List_62-74.jpg`}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/UVA-Library-Collection-List_62-74_thumb.jpg`}
                                    alt="Arthur Mervyn book cover"
                                    className="uva-thumbnail-img"
                                />
                            </a>
                            <div className="caption">
                                <h4>#62-74</h4>
                            </div>
                        </li>
                        <li className="uva-thumbnail-item">
                            <a href={`${process.env.PUBLIC_URL}/images/scans/UVA/UVA-Library-Collection-List_75-85.jpg`}>
                                <img
                                    src={`${process.env.PUBLIC_URL}/images/scans/UVA/thumbs/UVA-Library-Collection-List_75-85_thumb.jpg`}
                                    alt="Arthur Mervyn book cover"
                                    className="uva-thumbnail-img"
                                />
                            </a>
                            <div className="caption">
                                <h4>#75-85</h4>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default UVABibliography;
